import React from 'react'
import { useAuth } from '../../Context/ContextProvider'
import { FaFacebook } from 'react-icons/fa'
import { FaLinkedin } from 'react-icons/fa'
import { FaWhatsapp } from 'react-icons/fa'
import { BsTwitterX } from 'react-icons/bs'
import dummyImage from '../../Assete/dummy image.png'

function Content({ mediaDetail }) {
    const { base_url, loading } = useAuth()
    const currentUrl = window.location.href;
    const shareText = mediaDetail?.title || 'Media Story';
    const formatDate = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };
    return (
        <div>
            <div className='container blog-detail-container story-detail-container mb-5'>
                {!mediaDetail || loading ? <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}><div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div></div> : <div className='row m-0'>
                    <div className='col-12 col-md-6 col-lg-9 '>
                        <div className='d-flex align-items-center my-3'>
                            <img className='user-img mb-0' src={mediaDetail?.userPicture ? mediaDetail?.userPicture : dummyImage} alt={mediaDetail?.name} />
                            <div>
                                <h1 className='m-0 heading-title'>{mediaDetail?.name}</h1>
                                {/* <p className='mb-0'>{mediaDetail?.title}</p> */}
                            </div>


                        </div>
                        <div dangerouslySetInnerHTML={{ __html: mediaDetail?.storyContent }} />
                    </div>
                    <div className='col-12 col-md-6 col-lg-3 pt-4'>
                        <div className='p-3 author-details-container'>
                            <h5>Author Details</h5>
                            <div className='d-flex align-items-center justify-content-between'>
                                <h6 className='title'>Author</h6>
                                <p>{mediaDetail?.name}</p>
                            </div>
                            <div className='d-flex align-items-center justify-content-between'>
                                <h6 className='title'>Date</h6>
                                <p>{formatDate(mediaDetail?.createdAt)}</p>
                            </div>
                            <div className='d-flex align-items-center justify-content-between'>
                                <h6 className='title'>Affiliation</h6>
                                <p>{mediaDetail?.category}</p>
                            </div>
                            <div className='d-flex align-items-center justify-content-between'>
                                <h6 className='title'>Email</h6>
                                <p>{mediaDetail?.email}</p>
                            </div>
                        </div>

                        <div className='p-3 share-container'>
                            <h5 className='title'>Share</h5>
                            <div className='d-flex align-items-center gap-2'>
                                <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`} target='_blank' rel='noopener'>
                                    <FaFacebook style={{ fontSize: "20px" }} />
                                </a>
                                <a href={`https://www.twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(shareText)}`} target='_blank' rel='noopener'>
                                    <BsTwitterX style={{ fontSize: "20px" }} />
                                </a>
                                <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`} target='_blank' rel='noopener'>
                                    <FaLinkedin style={{ fontSize: "20px" }} />
                                </a>
                                <a href={`https://wa.me/?text=${encodeURIComponent(shareText + ' ' + currentUrl)}`} target='_blank' rel='noopener'>
                                    <FaWhatsapp style={{ fontSize: "20px" }} />
                                </a>
                            </div>
                        </div>
                    </div>

                </div>}
            </div>
        </div>
    )
}
export default Content